
import Button from '../base/Button';

export default function HeroSection() {
  const handleReserveClick = () => {
    const reservationSection = document.getElementById('contact');
    if (reservationSection) {
      reservationSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/7a81e037875ba9699c319612a5c3de16/17305cabc8593049d79afa1fe5f2015c.jpeg')`
      }}
    >
      {/* Animated background overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal-600/20 via-transparent to-blue-600/20 animate-pulse"></div>
      
      {/* Floating elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl animate-float"></div>
      <div className="absolute top-40 right-20 w-16 h-16 bg-teal-400/20 rounded-full blur-lg animate-float-delayed"></div>
      <div className="absolute bottom-32 left-20 w-12 h-12 bg-blue-400/15 rounded-full blur-md animate-float"></div>

      <div className="container mx-auto px-4 text-center text-white relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-6 py-2 bg-white/20 backdrop-blur-sm rounded-full border border-white/30 mb-8 animate-fade-in">
            <i className="ri-map-pin-line mr-2 text-teal-300"></i>
            <span className="text-sm font-medium">Parque Nacional Natural Tayrona</span>
          </div>

          {/* Main heading with enhanced styling */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight animate-slide-up">
            <span className="block text-white drop-shadow-2xl">Castilletes</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-teal-300 via-blue-30 to-teal-200 drop-shadow-lg">
              Parque Tayrona
            </span>
          </h1>

          {/* Subtitle with better typography */}
          <div className="mb-4 animate-slide-up-delayed">
            <p className="text-2xl md:text-3xl lg:text-4xl font-light text-teal-100 mb-2">
              La Única Forma de Despertar
            </p>
            <p className="text-2xl md:text-3xl lg:text-4xl font-light text-white mb-6">
              en este <span className="font-semibold text-teal-300">Paraíso</span>
            </p>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl lg:text-2xl mb-10 font-light text-gray-200 max-w-3xl mx-auto leading-relaxed animate-fade-in-delayed">
            Confort, Naturaleza y Playa a tus Pies
          </p>

          {/* Enhanced CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleReserveClick}
              className="font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white shadow-lg hover:shadow-xl px-8 py-4 text-lg text-lg px-12 py-5 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 shadow-2xl hover:shadow-teal-500/25 transform hover:scale-105 transition-all duration-300 border-2 border-teal-400/50"
            >
              <i className="ri-calendar-check-line mr-3 text-xl"></i>
              Reserva Tu Estadía Ahora
            </button>
            <button
              onClick={() => window.open('https://wa.me/573196152352?text=Hola, me interesa hacer una reserva en Castilletes Parque Tayrona', '_blank')}
              className="font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center px-8 py-4 text-lg px-12 py-5 bg-green-500 hover:bg-green-600 text-white shadow-2xl hover:shadow-green-500/25 transform hover:scale-105 transition-all duration-300 border-2 border-green-400/50"
            >
              <i className="ri-whatsapp-line mr-3 text-xl"></i>
              WhatsApp
            </button>
          </div>

          {/* Features highlight */}
          <div className="flex flex-wrap justify-center gap-8 mt-12 animate-fade-in-delayed">
            <div className="flex items-center text-white/90">
              <div className="w-12 h-12 bg-teal-500/30 rounded-full flex items-center justify-center mr-3 backdrop-blur-sm border border-teal-400/50">
                <i className="ri-home-smile-line text-xl text-teal-300"></i>
              </div>
              <span className="font-medium">Alojamiento </span>
            </div>
            <div className="flex items-center text-white/90">
              <div className="w-12 h-12 bg-blue-500/30 rounded-full flex items-center justify-center mr-3 backdrop-blur-sm border border-blue-400/50">
                <i className="ri-water-line text-xl text-blue-300"></i>
              </div>
              <span className="font-medium">Frente al Mar</span>
            </div>
            <div className="flex items-center text-white/90">
              <div className="w-12 h-12 bg-green-500/30 rounded-full flex items-center justify-center mr-3 backdrop-blur-sm border border-green-400/50">
                <i className="ri-leaf-line text-xl text-green-300"></i>
              </div>
              <span className="font-medium">Naturaleza Virgen</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enhanced scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center">
          <span className="text-white/80 text-sm mb-2 font-light">Descubre más</span>
          <div className="w-8 h-8 border-2 border-white/60 rounded-full flex items-center justify-center">
            <i className="ri-arrow-down-line text-white text-lg"></i>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(-180deg); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-up-delayed {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fade-in-delayed {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 8s ease-in-out infinite;
        }
        .animate-slide-up {
          animation: slide-up 1s ease-out;
        }
        .animate-slide-up-delayed {
          animation: slide-up-delayed 1s ease-out 0.3s both;
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out 0.5s both;
        }
        .animate-fade-in-delayed {
          animation: fade-in-delayed 1s ease-out 0.8s both;
        }
      `}</style>
    </section>
  );
}
